<template>
    <div>
        <modal name="auth-login" youtube="false" :visible="shown" :close="false" ref="modal">
            <form :action="`${base_api_url}/wp-json/auth/check-code`" method="GET" id="auth-login__form" v-on:submit.prevent="onSubmit">
                <h2 class="text-center">Teacher Login</h2>

                <div class="auth-login__error" v-if="error">
                    Sorry, there was an error, please try again.
                </div>
                <div class="auth-login__error" v-if="valid === false">
                    The access code was incorrect, please try again.
                </div>

                <div class="field">
                    <label for="auth-login--name">Name</label>
                    <input type="text" name="name" id="auth-login--name" value="" v-model="name" required />
                </div>
                <div class="field">
                    <label for="auth-login--school">School</label>
                    <input type="text" name="school" id="auth-login--school" value="" v-model="school" required />
                </div>
                <div class="field">
                    <label for="auth-login--code">Access Code</label>
                    <input type="text" name="code" id="auth-login--code" value="" v-model="code" required />
                </div>
                <div class="field field--submit">
                    <button
                        type="submit"
                        :class="[
                            {'bg-co-dark-grey-3 cursor-not-allowed hover:bg-co-dark-grey-3 focus:bg-co-dark-grey-3 border-co-dark-grey-3 hover:border-co-dark-grey-3 focus:border-co-dark-grey-3': loading},
                            'btn bg-co-blue mx-auto py-3 px-5 text-lg text-white'
                        ]"
                        :disabled="loading">Login</button>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
import Modal from './Modal.vue'

export default {
    name: 'login',
    components: {
        Modal,
    },
    props: {
        show: {
            type: Boolean,
            required: false,
            default: false,
        },
        base_api_url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            name: '',
            school: '',
            code: '',
            shown: this.show,
            valid: null,
            error: false,
            loading: false,
        }
    },
    methods: {
        cookieValueEncoded: function () {
            return btoa(`${this.name}--${this.school}--${this.code}`)
        },
        cookieValueDecoded: function (value) {
            return atob(value)
        },
        setCookie: function () {
            this.$cookies.set('auth', this.cookieValueEncoded())
            this.$cookies.set('name', this.name)
            this.$cookies.set('school', this.school)
            this.$cookies.set('code', this.code)
        },
        onSubmit: function (event) {
            this.loading = true

            axios({
                url: event.target.action,
                method: event.target.method,
                data: {
                    code: this.code,
                },
                params: {
                    code: this.code,
                }
            }).then(response => {
                this.valid = response.data.valid
                this.error = false
                this.loading = false

                if (this.valid) {
                    this.$refs.modal.closeModal()
                    this.setCookie()

                    if (typeof ga === 'function') {
                        ga('send', 'event', 'Teaching Resources', 'Login', `${this.name} / ${this.school}`)
                    }

                    this.$emit('logged-in', true)
                }
            })
            .catch(error => {
                this.valid = false
                this.error = true
                this.loading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    form {
        @apply block p-6;
    }

    .field {
        @apply py-4;

        label {
            @apply block pb-2;
        }

        input {
            @apply block w-full p-4 border border-co-dark-grey rounded-lg;
        }

        &--submit {
            @apply text-center;
        }
    }

    .auth-login {
        @apply w-full;

        &__error {
            @apply text-strong-red text-2xl py-4 text-center;
        }
    }
</style>
